class Menu {
  constructor() {
    this.menuToggle = document.querySelector(".menu-toggle");
    this.menuMobile = document.querySelector(".menu-mobile");
    this.menuClose = document.querySelector(".menu-mobile-close");

    this.bindEvents();
  }

  bindEvents() {
    if (this.menuToggle && this.menuMobile && this.menuClose) {
      // Apre il menu
      this.menuToggle.addEventListener("click", () => {
        this.menuMobile.classList.add("menu-mobile-open");
      });

      // Chiude il menu
      this.menuClose.addEventListener("click", () => {
        this.menuMobile.classList.remove("menu-mobile-open");
      });
    }
  }
}

export default Menu;
